import { lazy, Suspense } from 'react';
import { Navigate, useRoutes } from 'react-router-dom';
// auth
import { GuestGuard } from 'src/auth/guard';
// layouts
import MainLayout from 'src/layouts/main';
import { LoadingScreen } from 'src/components/loading-screen';
// config
// import { PATH_AFTER_LOGIN } from 'src/config-global';
//
import { admindashboardRoutes } from './admin-dashboard';
import { authRoutes } from './auth';
import { authDemoRoutes } from './auth-demo';
import { dashboardRoutes } from './contractor-dashboard';
import { HomePage, mainRoutes } from './main';
import { superadmindashboardRoutes } from './superadmin-dashboard';
import {ShopAdminDashboard} from './shop-admin-dashboard'

import AuthClassicLayout from 'src/layouts/auth/classic';
import { componentsRoutes } from './components';
import HealthView from 'src/sections/health/view';
import QuotePaymentPage from 'src/pages/main-dashboard/quote/quote-payment-page';
const JwtLoginPage = lazy(() => import('src/pages/auth/jwt/login'));
const JwtRegisterPage = lazy(() => import('src/pages/auth/jwt/register'));
const MarketingPage = lazy(() => import('src/pages/marketing-page'));
const DocsPage = lazy(() => import('src/pages/docs'));

// ----------------------------------------------------------------------

export default function Router() {
  return useRoutes([
    // SET INDEX PAGE WITH SKIP HOME PAGE
    // {
    //   path: '/',
    //   element: <Navigate to={PATH_AFTER_LOGIN} replace />,
    // },

    // ----------------------------------------------------------------------

    // SET INDEX PAGE WITH HOME PAGE
    {
      path: '/',
      element: (
        <MainLayout>
          <HomePage />
        </MainLayout>
      ),
    },
    {
      path: '/health',
      element: (
        <MainLayout>
          <HealthView />
        </MainLayout>
      ),
    },
    {
      path: '/marketing/:slug',
      element: (
        <MainLayout>
          <MarketingPage />
        </MainLayout>
      ),
    },
    {
      // Public user manual - open to everyone, no sign-in required
      path: '/docs',
      element: (
        <Suspense fallback={<LoadingScreen />}>
          <DocsPage />
        </Suspense>
      ),
    },
    {
      path: '/login',
      element: (
        <GuestGuard>
          <AuthClassicLayout>
            <JwtLoginPage />
          </AuthClassicLayout>
        </GuestGuard>
      ),
    },
    {
      path: '/register',
      element: (
        <GuestGuard>
          <AuthClassicLayout>
            <JwtRegisterPage />
          </AuthClassicLayout>
        </GuestGuard>
      ),
    },

    // Auth routes
    ...authRoutes,
    ...authDemoRoutes,
    //  Dashboard routes
    ...dashboardRoutes,

    //super-admin dashboard
    ...superadmindashboardRoutes,

    //shop-admin dashboard
    ...ShopAdminDashboard,

    //user-dashboard
    ...admindashboardRoutes,

    // Main routes
    ...mainRoutes,

    // Components routes
    ...componentsRoutes,

    // No match 404
    { path: '*', element: <Navigate to="/404" replace /> },
  ]);
}
